module.exports = __webpack_public_path__ + "static/media/cesped_otoño_largo.d9861685.jpg";